import { render, staticRenderFns } from "./WebPropertiesOverview.vue?vue&type=template&id=5db2665c&scoped=true&"
import script from "./WebPropertiesOverview.vue?vue&type=script&lang=js&"
export * from "./WebPropertiesOverview.vue?vue&type=script&lang=js&"
import style0 from "./WebPropertiesOverview.vue?vue&type=style&index=0&id=5db2665c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db2665c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VDataTable,VProgressCircular,VTextField})
